export interface IRouterHelper {
    name: string;
    path: string;
    params?: { [key: string]: any };
    query?: { [key: string]: any };
    type?: string;
    action?: string;
    save?: { [key: string]: any };
}

export default class RouterHelper implements IRouterHelper {
    name: string;
    path: string;
    params?: { [key: string]: any };
    query?: { [key: string]: any };
    type?: string;
    action?: string;
    save?: { [key: string]: any };

    constructor(props?: IRouterHelper) {
        this.name = props.name || '';
        this.path = props.path || '';
        this.params = props.params || {};
        this.query = props.query || {};
        this.type = props.type || '';
        this.action = props.action || '';
        this.save = props.save || {};
    }
}
